module.exports = __webpack_public_path__ + "f.no1.c55fc514.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/f.no1.jpg
// module id = vMsR
// module chunks = 0